import {AbstractControl} from "@angular/forms";
import {Injectable} from "@angular/core";
import {DetailService} from "./details/detail.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";


/**
 * Class > ValidationService
 */
@Injectable()
export class ValidationService
{


	/**
	 * Function > constructor
	 * @param {DetailService} OBJ_detail_service
	 * @param {HttpClient} OBJ_http_client
	 */
	constructor(private OBJ_detail_service: DetailService, private OBJ_http_client: HttpClient) { } // end function constructor


	/**
	 * Function > checkEmail
	 * @param {AbstractControl} OBJ_abstract_control
	 * @return {any}
	 */
	static checkEmail(OBJ_abstract_control: AbstractControl)
	{

		// RFC 2822 compliant regex
		let EMAIL_REGEX = /[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?/;

		if (OBJ_abstract_control.value == null)
		{
			return null;
		} // end if

		// array of email addresses
		if (Array.isArray(OBJ_abstract_control.value))
		{

			// go through array
			for (let item of OBJ_abstract_control.value)
			{
				// valid email address? sometimes several adresses are written in one field, so check also if matched field equals item
				if (item.match(EMAIL_REGEX) === null || item.match(EMAIL_REGEX)[0] !== item.trim())
				{
					return {checkEmail: {valid: false}};
				} // end if

			} // end for

			return null;

		}
		else
		{
			return OBJ_abstract_control.value.match(EMAIL_REGEX) ? null : {checkEmail: {valid: false}};
		} // end if

	} // end function checkEmail


	/**
	 * Function > numeric
	 * @param {AbstractControl} OBJ_abstract_control
	 * @return {any}
	 */
	static numeric(OBJ_abstract_control: AbstractControl)
	{

		let STR_value = OBJ_abstract_control.value;
		if (STR_value == null || STR_value === '')
		{
			return null;
		} // end if

		// RFC 2822 compliant regex
		let NUMERIC_REGEX = /^\d+(\.\d+)?$/;
		return STR_value.toString().match(NUMERIC_REGEX) ? null : {invalidNumber: {valid: false}};

	} // end function numeric


	/**
	 * Function > json
	 * @param {AbstractControl} OBJ_abstract_control
	 * @return {any}
	 */
	static json(OBJ_abstract_control: AbstractControl)
	{

		let STR_value = OBJ_abstract_control.value;
		if (STR_value == null || STR_value === '')
		{
			return null;
		} // end if

		try
		{
			let STR_json = JSON.parse(STR_value);

			// Handle non-exception-throwing cases:
			// Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
			// but... JSON.parse(null) returns null, and typeof null === "object",
			// so we must check for that, too. Thankfully, null is falsey, so this suffices:
			if (STR_json && typeof STR_json === "object")
			{
				return null;
			} // end if
		}
		catch (e)
		{} // end try/catch

		return {json: {valid:false}};

	} // end function numeric


	/**
	 * Function > matchPassword
	 * @param {AbstractControl} OBJ_abstract_control
	 * @return {any}
	 */
	static matchPassword(OBJ_abstract_control: AbstractControl)
	{

		let STR_password = OBJ_abstract_control.get("password").value; // to get value in input tag
		let STR_confirm_password = OBJ_abstract_control.get("password_confirm").value; // to get value in input tag
		return (STR_password == STR_confirm_password) ? null : {matchPassword: {valid: false}};

	} // end function matchPassword


	/**
	 * Function > checkPassword
	 * @param {AbstractControl} OBJ_abstract_control
	 * @return {any}
	 */
	static checkPassword(OBJ_abstract_control: AbstractControl)
	{

		if (OBJ_abstract_control.value == null)
		{
			return null;
		} // end if

		// Minimum 10 and maximum 30 characters, at least one uppercase letter, one lowercase letter, one number and one special character
		let PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\$@§!%*\-+_?&#^,.])[A-Za-z\d\$@§!%*\-+_?&#^,.]{10,30}$/;
		return OBJ_abstract_control.value.match(PASSWORD_REGEX) ? null : {checkPassword: {valid: false}};

	} // end function checkPassword


	/**
	 * Function > checkUrl
	 * @param {AbstractControl} OBJ_abstract_control
	 * @return {any}
	 */
	static checkUrl(OBJ_abstract_control: AbstractControl)
	{

		if (OBJ_abstract_control.value == null)
		{
			return null;
		} // end if

		let URL_REGEX = /^$|(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+\.[^\s]{2,})/g;
		return OBJ_abstract_control.value.match(URL_REGEX) ? null : {checkUrl: {valid: true}};

	} // end function checkUrl

	/**
	 * Function > checkApiMatch
	 * @param OBJ_givenParams { apiUrl: string, control: AbstractControl }
	 * @return {any}
	 */
	checkApiMatch(OBJ_givenParams)
	{
		let OBJ_abstract_control: AbstractControl = OBJ_givenParams.control;
		let OBJ_params = new HttpParams().set('searchtext', OBJ_abstract_control.value).set('searchfields', OBJ_givenParams.name).set('exactmatch', OBJ_givenParams.exact_match).set('excluded_id', OBJ_givenParams.itemId);
		return this.OBJ_detail_service.getHelper(OBJ_givenParams.apiUrl, OBJ_params);

	} // end function checkUrl


} // end class ValidationService
